// // LandingPage.tsx
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import {
//   FaUserClock,
//   FaMapMarkerAlt,
//   FaCalculator,
//   FaChartLine,
//   FaMobileAlt,
//   FaShieldAlt,
//   FaSync,
//   FaCheckCircle,
//   FaArrowRight,
//   FaUsers,
//   FaFileInvoiceDollar,
//   FaRobot,
//   FaWhatsapp,
//   FaShoppingCart,
//   FaCreditCard,
//   FaClock,
//   FaCloud,
//   FaLock,
//   FaEye,
//   FaEyeSlash,
//   FaBars,
//   FaTimes,
// } from "react-icons/fa";
// import { Button } from "../components/ui/button";
// import { Input } from "../components/ui/input";
// import { Label } from "../components/ui/label";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
//   CardDescription,
// } from "../components/ui/card";
// import { useToast } from "../hooks/useToast";
// import { useAuth } from "../contexts/AuthContext";

// type LoginForm = {
//   email: string;
//   password: string;
// };

// const LandingPage: React.FC = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [activeFeature, setActiveFeature] = useState(0);

//   const navigate = useNavigate();
//   const { toast } = useToast();
//   const { login, user } = useAuth();

//   useEffect(() => {
//   if (user) {
//     navigate("/dashboard");
//   }
// }, [user]);

//   const { register, handleSubmit } = useForm<LoginForm>();

//   const features = [
//     {
//       icon: <FaMapMarkerAlt />,
//       title: "Location-Based Attendance",
//       description:
//         "Track employee attendance automatically from any location using GPS and geofencing technology.",
//       color: "bg-blue-500",
//     },
//     {
//       icon: <FaCalculator />,
//       title: "Automated Payroll Processing",
//       description:
//         "Calculate salaries, taxes, and deductions automatically based on attendance data.",
//       color: "bg-green-500",
//     },
//     {
//       icon: <FaChartLine />,
//       title: "AI-Powered Analytics",
//       description:
//         "Get insights into workforce productivity with AI-driven analytics and reports.",
//       color: "bg-purple-500",
//     },
//     {
//       icon: <FaMobileAlt />,
//       title: "Mobile App & WhatsApp",
//       description:
//         "Employees can mark attendance, view payslips via mobile app or WhatsApp.",
//       color: "bg-orange-500",
//     },
//     {
//       icon: <FaShieldAlt />,
//       title: "Bank-Level Security",
//       description:
//         "End-to-end encryption, multi-factor authentication, and data protection compliance.",
//       color: "bg-red-500",
//     },
//     {
//       icon: <FaSync />,
//       title: "Auto Reconciliation",
//       description:
//         "Advanced auto reconciliations with seamless bank statement imports.",
//       color: "bg-teal-500",
//     },
//   ];

//   const stats = [
//     { value: "10,000+", label: "Happy Companies" },
//     { value: "₹399", label: "Starting Price/Month" },
//     { value: "99.9%", label: "Uptime" },
//     { value: "24/7", label: "Support" },
//   ];

//   const onSubmit = async (data: LoginForm) => {
//     try {
//       setLoading(true);
//       await login(data.email, data.password);

//       toast({
//         title: "Success",
//         description: "Logged in successfully",
//       });

//       navigate("/dashboard");
//     } catch (error) {
//       toast({
//         variant: "destructive",
//         title: "Error",
//         description: "Invalid credentials",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveFeature((prev) => (prev + 1) % features.length);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   const scrollToSection = (sectionId: string) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//       setIsMenuOpen(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
//       {/* Fixed Navigation */}
//       <nav className="fixed w-full top-0 left-0 bg-white/90 backdrop-blur-md z-50 shadow-sm">
//         <div className="container mx-auto px-4 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-2">
//               <FaUserClock className="text-blue-600 text-2xl" />
//               <span className="text-xl font-bold text-gray-900">
//                 HRPayroll
//               </span>
//             </div>

//             {/* Desktop Navigation */}
//             <div className="hidden md:flex items-center space-x-8">
//               <button
//                 onClick={() => scrollToSection("home")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Home
//               </button>
//               <button
//                 onClick={() => scrollToSection("features")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Features
//               </button>
//               <button
//                 onClick={() => scrollToSection("pricing")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Pricing
//               </button>
//               <button
//                 onClick={() => scrollToSection("login")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Login
//               </button>
//             </div>

//             {/* Mobile Menu Button */}
//             <button
//               className="md:hidden text-gray-700"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//             >
//               {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//             </button>
//           </div>

//           {/* Mobile Menu */}
//           {isMenuOpen && (
//             <div className="md:hidden mt-4 pb-4 animate-in slide-in-from-top">
//               <div className="flex flex-col space-y-4">
//                 <button
//                   onClick={() => scrollToSection("home")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Home
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("features")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Features
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("pricing")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Pricing
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("login")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Login
//                 </button>
//                 <Button
//                   onClick={() => scrollToSection("register")}
//                   className="bg-blue-600 hover:bg-blue-700 w-full"
//                 >
//                   Start Free Trial
//                 </Button>
//               </div>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <section id="home" className="pt-24 pb-16 md:pt-32 md:pb-24 px-4">
//         <div className="container mx-auto">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div>
//               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
//                 The Ultimate HR Payroll Platform
//                 {/* <span className="text-blue-600 block">With AI Automation</span> */}
//               </h1>
//               <p className="text-lg text-gray-600 mb-8">
//                 HRPayroll offers cutting-edge HR & Payroll Software for seamless
//                 workforce management. Our advanced platform integrates AI
//                 technology, automatic attendance tracking from any location, tax
//                 filing, and mobile solutions, revolutionizing the HR landscape.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <Button
//                   onClick={() => scrollToSection("register")}
//                   className="bg-blue-600 hover:bg-blue-700 px-8 py-6 text-lg"
//                 >
//                   <span>Start Today, Right Now</span>
//                   <FaArrowRight className="ml-2" />
//                 </Button>
//                 <Button
//                   onClick={() => scrollToSection("pricing")}
//                   variant="outline"
//                   className="px-8 py-6 text-lg"
//                 >
//                   View Pricing
//                 </Button>
//               </div>
//               <p className="mt-6 text-gray-500">
//                 <FaClock className="inline mr-2" />
//                 Paid plans starting from{" "}
//                 <span className="font-bold text-blue-600">₹399/month</span>
//               </p>
//             </div>

//             {/* Hero Image/Animation */}
//             <div className="relative">
//               <Card className="shadow-2xl border-0">
//                 <CardContent className="p-6">
//                   <div className="text-center mb-6">
//                     <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FaUserClock className="text-blue-600 text-2xl" />
//                     </div>
//                     <h3 className="text-xl font-bold">
//                       Live Dashboard Preview
//                     </h3>
//                   </div>

//                   {/* Feature Carousel */}
//                   <div className="mb-6">
//                     <div
//                       className={`p-4 rounded-lg ${features[activeFeature].color} text-white transition-all duration-500`}
//                     >
//                       <div className="flex items-center mb-2">
//                         <div className="text-2xl mr-3">
//                           {features[activeFeature].icon}
//                         </div>
//                         <h4 className="font-bold">
//                           {features[activeFeature].title}
//                         </h4>
//                       </div>
//                       <p className="text-sm">
//                         {features[activeFeature].description}
//                       </p>
//                     </div>

//                     {/* Feature Dots */}
//                     <div className="flex justify-center space-x-2 mt-4">
//                       {features.map((_, index) => (
//                         <button
//                           key={index}
//                           onClick={() => setActiveFeature(index)}
//                           className={`w-2 h-2 rounded-full ${index === activeFeature ? "bg-blue-600" : "bg-gray-300"}`}
//                         />
//                       ))}
//                     </div>
//                   </div>

//                   {/* Stats */}
//                   <div className="grid grid-cols-2 gap-4">
//                     <div className="bg-gray-50 p-4 rounded-lg">
//                       <div className="text-2xl font-bold text-blue-600">
//                         142
//                       </div>
//                       <div className="text-sm text-gray-600">Active Today</div>
//                     </div>
//                     <div className="bg-gray-50 p-4 rounded-lg">
//                       <div className="text-2xl font-bold text-green-600">
//                         89
//                       </div>
//                       <div className="text-sm text-gray-600">
//                         Remote Workers
//                       </div>
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>

//               {/* Floating Elements */}
//               <div className="absolute -top-4 -right-4 bg-white p-4 rounded-xl shadow-lg">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
//                     <FaCheckCircle className="text-green-600" />
//                   </div>
//                   <div className="ml-3">
//                     <div className="font-bold">AI Powered</div>
//                     <div className="text-sm text-gray-500">Real-time</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-12 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//             {stats.map((stat, index) => (
//               <div key={index} className="text-center">
//                 <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
//                   {stat.value}
//                 </div>
//                 <div className="text-gray-600">{stat.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section id="features" className="py-16 px-4">
//         <div className="container mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Why Choose HRPayroll?
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Our advanced AI-Powered automation and seamless integrations
//               eliminate manual efforts, guaranteeing a smooth HR and payroll
//               experience.
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {features.map((feature, index) => (
//               <Card key={index} className="hover:shadow-xl transition-shadow">
//                 <CardContent className="p-6">
//                   <div
//                     className={`${feature.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}
//                   >
//                     <div className="text-white text-xl">{feature.icon}</div>
//                   </div>
//                   <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
//                   <p className="text-gray-600">{feature.description}</p>
//                 </CardContent>
//               </Card>
//             ))}
//           </div>

//           {/* Additional Features */}
//           <div className="mt-16 grid md:grid-cols-3 gap-8">
//             <div className="text-center">
//               <FaRobot className="text-4xl text-blue-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">AI-Powered Automation</h4>
//               <p className="text-gray-600">
//                 Smart automation for payroll calculations and compliance
//               </p>
//             </div>
//             <div className="text-center">
//               <FaWhatsapp className="text-4xl text-green-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">WhatsApp Integration</h4>
//               <p className="text-gray-600">
//                 Send payslips and alerts via WhatsApp instantly
//               </p>
//             </div>
//             <div className="text-center">
//               <FaCloud className="text-4xl text-purple-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">Cloud Platform</h4>
//               <p className="text-gray-600">
//                 Access from anywhere, anytime with 99.9% uptime
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Login/Register Section */}
//       <section
//         id="login"
//         className="py-16 px-4 bg-gradient-to-r from-blue-50 to-indigo-50"
//       >
//         <div className="container mx-auto max-w-6xl">
//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* Login Form */}
//             <Card className="shadow-xl">
//               <CardHeader>
//                 <CardTitle>Login to Your Account</CardTitle>
//                 <CardDescription>
//                   Enter your credentials to access the HR dashboard
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
//                   <div className="space-y-2">
//                     <Label htmlFor="email">Email</Label>
//                     <Input
//                       id="email"
//                       type="email"
//                       placeholder="Enter your email"
//                       {...register("email", { required: true })}
//                     />
//                   </div>
//                   <div className="space-y-2">
//                     <Label htmlFor="password">Password</Label>
//                     <div className="relative">
//                       <Input
//                         id="password"
//                         type={showPassword ? "text" : "password"}
//                         placeholder="Enter your password"
//                         {...register("password", { required: true })}
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="absolute right-3 top-3 text-gray-500"
//                       >
//                         {showPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                   </div>
//                   <Button type="submit" className="w-full" disabled={loading}>
//                     {loading ? "Loading..." : "Sign In"}
//                   </Button>
//                 </form>
//                 <div className="mt-4 text-center">
//                   <button
//                     onClick={() => navigate("/forgot-password")}
//                     className="text-sm text-blue-600 hover:underline"
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Register CTA */}
//             <div id="register">
//               <Card className="shadow-xl bg-gradient-to-br from-blue-600 to-blue-800 text-white">
//                 <CardContent className="p-8">
//                   <div className="text-center mb-6">
//                     <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FaUserClock className="text-2xl" />
//                     </div>
//                     <h3 className="text-2xl font-bold mb-2">
//                       Start Your Free Trial
//                     </h3>
//                     <p className="text-blue-100 mb-6">
//                       Join thousands of companies already using HRPayroll
//                     </p>
//                   </div>

//                   <div className="space-y-4 mb-6">
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>30-day free trial</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>No credit card required</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>Full access to all features</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>Priority support</span>
//                     </div>
//                   </div>

//                   <Button
//                     onClick={() => navigate("/register")}
//                     className="w-full bg-white text-blue-600 hover:bg-gray-100"
//                   >
//                     Register Now
//                   </Button>

//                   <p className="text-center mt-4 text-blue-200 text-sm">
//                     Paid plans starting from ₹399/month after trial
//                   </p>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       <section id="pricing" className="py-16 px-4">
//         <div className="container mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Simple, Transparent Pricing
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Choose the perfect plan for your business needs
//             </p>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
//             {/* Basic Plan */}
//             <Card className="text-center">
//               <CardContent className="p-6">
//                 <h3 className="text-xl font-bold mb-2">Starter</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   ₹399<span className="text-sm text-gray-500">/month</span>
//                 </div>
//                 <p className="text-gray-600 mb-6">
//                   Perfect for small businesses
//                 </p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Up to 10 employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Basic payroll processing</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Mobile attendance</span>
//                   </div>
//                 </div>
//                 <Button className="w-full">Get Started</Button>
//               </CardContent>
//             </Card>

//             {/* Popular Plan */}
//             <Card className="text-center border-2 border-blue-600 shadow-xl relative">
//               <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
//                 <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm">
//                   MOST POPULAR
//                 </span>
//               </div>
//               <CardContent className="p-6 pt-10">
//                 <h3 className="text-xl font-bold mb-2">Professional</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   ₹899<span className="text-sm text-gray-500">/month</span>
//                 </div>
//                 <p className="text-gray-600 mb-6">Best for growing companies</p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Up to 50 employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>AI-powered analytics</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Auto reconciliations</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>WhatsApp integration</span>
//                   </div>
//                 </div>
//                 <Button className="w-full bg-blue-600 hover:bg-blue-700">
//                   Try Free for 30 Days
//                 </Button>
//               </CardContent>
//             </Card>

//             {/* Enterprise Plan */}
//             <Card className="text-center">
//               <CardContent className="p-6">
//                 <h3 className="text-xl font-bold mb-2">Enterprise</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   Custom
//                 </div>
//                 <p className="text-gray-600 mb-6">For large organizations</p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Unlimited employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Custom integrations</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Dedicated support</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>API access</span>
//                   </div>
//                 </div>
//                 <Button className="w-full">Contact Sales</Button>
//               </CardContent>
//             </Card>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-900 text-white py-12 px-4">
//         <div className="container mx-auto">
//           <div className="grid md:grid-cols-4 gap-8">
//             <div>
//               <div className="flex items-center space-x-2 mb-4">
//                 <FaUserClock className="text-2xl text-blue-400" />
//                 <span className="text-xl font-bold">HRPayroll</span>
//               </div>
//               <p className="text-gray-400">
//                 Revolutionizing HR management with automated attendance tracking
//                 and payroll processing.
//               </p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <ul className="space-y-2">
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("home")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Home
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("features")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Features
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("pricing")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Pricing
//                   </button>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Resources</h4>
//               <ul className="space-y-2">
//                 <li>
//                   <button
//                     onClick={() => navigate("/blog")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Blog
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => navigate("/docs")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Documentation
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => navigate("/support")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Support
//                   </button>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <ul className="space-y-2 text-gray-400">
//                 <li>info@startupkhata.com support@startupkhata.com</li>
//                 {/* <li>+91 12345 67890</li> */}
//                 <li>24/7 Support Available</li>
//               </ul>
//             </div>
//           </div>

//           <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
//             <p>
//               &copy; {new Date().getFullYear()} HRPayroll. All rights reserved.
//             </p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default LandingPage;



// LandingPage.tsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  FaUserClock,
  FaMapMarkerAlt,
  FaCalculator,
  FaChartLine,
  FaMobileAlt,
  FaShieldAlt,
  FaSync,
  FaCheckCircle,
  FaArrowRight,
  FaUsers,
  FaFileInvoiceDollar,
  FaRobot,
  FaWhatsapp,
  FaShoppingCart,
  FaCreditCard,
  FaClock,
  FaCloud,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaBars,
  FaTimes,
  FaBuilding,
} from "react-icons/fa";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "../components/ui/card";
import { useToast } from "../hooks/useToast";
import { useAuth } from "../contexts/AuthContext";
import { getOrganizations } from "../api/auth";

type LoginForm = {
  email: string;
  password: string;
};

interface Organization {
  head_office_id: string;
  company_name: string;
  organization: string;
}

const LandingPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  
  // Login flow states
  const [loginStep, setLoginStep] = useState<"email" | "organizations" | "login">("email");
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null);
  const [loginEmail, setLoginEmail] = useState("");

  const navigate = useNavigate();
  const { toast } = useToast();
  const { login, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user]);

  const { register, handleSubmit, getValues } = useForm<LoginForm>();

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Location-Based Attendance",
      description:
        "Track employee attendance automatically from any location using GPS and geofencing technology.",
      color: "bg-blue-500",
    },
    {
      icon: <FaCalculator />,
      title: "Automated Payroll Processing",
      description:
        "Calculate salaries, taxes, and deductions automatically based on attendance data.",
      color: "bg-green-500",
    },
    {
      icon: <FaChartLine />,
      title: "AI-Powered Analytics",
      description:
        "Get insights into workforce productivity with AI-driven analytics and reports.",
      color: "bg-purple-500",
    },
    {
      icon: <FaMobileAlt />,
      title: "Mobile App & WhatsApp",
      description:
        "Employees can mark attendance, view payslips via mobile app or WhatsApp.",
      color: "bg-orange-500",
    },
    {
      icon: <FaShieldAlt />,
      title: "Bank-Level Security",
      description:
        "End-to-end encryption, multi-factor authentication, and data protection compliance.",
      color: "bg-red-500",
    },
    {
      icon: <FaSync />,
      title: "Auto Reconciliation",
      description:
        "Advanced auto reconciliations with seamless bank statement imports.",
      color: "bg-teal-500",
    },
  ];

  const stats = [
    { value: "10,000+", label: "Happy Companies" },
    { value: "₹399", label: "Starting Price/Month" },
    { value: "99.9%", label: "Uptime" },
    { value: "24/7", label: "Support" },
  ];

  // Step 1: Get organizations by email
  const handleGetOrganizations = async (data: LoginForm) => {
    try {
      console.log("LandingPage: Getting organizations for email:", data.email);
      setLoading(true);
      setLoginEmail(data.email);

      const response = await getOrganizations(data.email);
      console.log("LandingPage: Organizations response:", response);

      if (response.success && response.organizations && response.organizations.length > 0) {
        setOrganizations(response.organizations);
        
        // If only one organization, auto-select it and go to login
        if (response.organizations.length === 1) {
          const singleOrg = response.organizations[0];
          setSelectedOrg(singleOrg);
          setLoginStep("login");
          toast({
            title: "Success",
            description: `Logged in to ${singleOrg.company_name}`,
          });
        } else {
          // Multiple organizations - show selection screen
          setLoginStep("organizations");
          toast({
            title: "Success",
            description: `Found ${response.organizations.length} organizations. Please select one.`,
          });
        }
      } else {
        toast({
          // title: "Error",
          description: "No organizations found for this email",
          variant: "destructive",
        });
      }
    } catch (error: any) {
      console.error("LandingPage: Error getting organizations:", error);
      toast({
        // title: "Error",
        description: error.message || "Failed to fetch organizations",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Select organization (only shown when multiple organizations exist)
  const handleSelectOrganization = (org: Organization) => {
    setSelectedOrg(org);
    setLoginStep("login");
  };

  // Step 3: Complete login with email, password, and head_office_id
  const handleCompleteLogin = async (data: LoginForm) => {
    if (!selectedOrg) {
      toast({
        // title: "Error",
        description: "Please select an organization first",
        variant: "destructive",
      });
      return;
    }

    try {
      console.log("LandingPage: Completing login with organization:", selectedOrg.head_office_id);
      setLoading(true);

      // Call login with email, password, and head_office_id
      await login(loginEmail, data.password, selectedOrg.head_office_id);

      toast({
        title: "Success",
        description: `Logged in to ${selectedOrg.company_name} successfully`,
      });

      navigate("/dashboard");
    } catch (error: any) {
      console.error("LandingPage: Login error occurred:", error);
      toast({
        variant: "destructive",
        // title: "Error",
        description: error.message || "Invalid credentials",
      });
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data: LoginForm) => {
    if (loginStep === "email") {
      await handleGetOrganizations(data);
    } else if (loginStep === "login") {
      await handleCompleteLogin(data);
    }
  };

  const handleBackToEmail = () => {
    setLoginStep("email");
    setOrganizations([]);
    setSelectedOrg(null);
  };

  const handleBackToOrganizations = () => {
    setLoginStep("organizations");
    setSelectedOrg(null);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Fixed Navigation */}
      <nav className="fixed w-full top-0 left-0 bg-white/90 backdrop-blur-md z-50 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <FaUserClock className="text-blue-600 text-2xl" />
              <span className="text-xl font-bold text-gray-900">
                HRPayroll
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection("home")}
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection("features")}
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection("pricing")}
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection("login")}
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Login
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-gray-700"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 animate-in slide-in-from-top">
              <div className="flex flex-col space-y-4">
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-gray-700 hover:text-blue-600 py-2"
                >
                  Home
                </button>
                <button
                  onClick={() => scrollToSection("features")}
                  className="text-gray-700 hover:text-blue-600 py-2"
                >
                  Features
                </button>
                <button
                  onClick={() => scrollToSection("pricing")}
                  className="text-gray-700 hover:text-blue-600 py-2"
                >
                  Pricing
                </button>
                <button
                  onClick={() => scrollToSection("login")}
                  className="text-gray-700 hover:text-blue-600 py-2"
                >
                  Login
                </button>
                <Button
                  onClick={() => scrollToSection("register")}
                  className="bg-blue-600 hover:bg-blue-700 w-full"
                >
                  Start Free Trial
                </Button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-24 pb-16 md:pt-32 md:pb-24 px-4">
        <div className="container mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                The Ultimate HR Payroll Platform
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                HRPayroll offers cutting-edge HR & Payroll Software for seamless
                workforce management. Our advanced platform integrates AI
                technology, automatic attendance tracking from any location, tax
                filing, and mobile solutions, revolutionizing the HR landscape.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  onClick={() => scrollToSection("register")}
                  className="bg-blue-600 hover:bg-blue-700 px-8 py-6 text-lg"
                >
                  <span>Start Today, Right Now</span>
                  <FaArrowRight className="ml-2" />
                </Button>
                <Button
                  onClick={() => scrollToSection("pricing")}
                  variant="outline"
                  className="px-8 py-6 text-lg"
                >
                  View Pricing
                </Button>
              </div>
              <p className="mt-6 text-gray-500">
                <FaClock className="inline mr-2" />
                Paid plans starting from{" "}
                <span className="font-bold text-blue-600">₹399/month</span>
              </p>
            </div>

            {/* Hero Image/Animation */}
            <div className="relative">
              <Card className="shadow-2xl border-0">
                <CardContent className="p-6">
                  <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <FaUserClock className="text-blue-600 text-2xl" />
                    </div>
                    <h3 className="text-xl font-bold">
                      Live Dashboard Preview
                    </h3>
                  </div>

                  {/* Feature Carousel */}
                  <div className="mb-6">
                    <div
                      className={`p-4 rounded-lg ${features[activeFeature].color} text-white transition-all duration-500`}
                    >
                      <div className="flex items-center mb-2">
                        <div className="text-2xl mr-3">
                          {features[activeFeature].icon}
                        </div>
                        <h4 className="font-bold">
                          {features[activeFeature].title}
                        </h4>
                      </div>
                      <p className="text-sm">
                        {features[activeFeature].description}
                      </p>
                    </div>

                    {/* Feature Dots */}
                    <div className="flex justify-center space-x-2 mt-4">
                      {features.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setActiveFeature(index)}
                          className={`w-2 h-2 rounded-full ${index === activeFeature ? "bg-blue-600" : "bg-gray-300"}`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Stats */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="text-2xl font-bold text-blue-600">
                        142
                      </div>
                      <div className="text-sm text-gray-600">Active Today</div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="text-2xl font-bold text-green-600">
                        89
                      </div>
                      <div className="text-sm text-gray-600">
                        Remote Workers
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-white p-4 rounded-xl shadow-lg">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <FaCheckCircle className="text-green-600" />
                  </div>
                  <div className="ml-3">
                    <div className="font-bold">AI Powered</div>
                    <div className="text-sm text-gray-500">Real-time</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-16 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose HRPayroll?
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our advanced AI-Powered automation and seamless integrations
              eliminate manual efforts, guaranteeing a smooth HR and payroll
              experience.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <Card key={index} className="hover:shadow-xl transition-shadow">
                <CardContent className="p-6">
                  <div
                    className={`${feature.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}
                  >
                    <div className="text-white text-xl">{feature.icon}</div>
                  </div>
                  <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Additional Features */}
          <div className="mt-16 grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <FaRobot className="text-4xl text-blue-600 mx-auto mb-4" />
              <h4 className="font-bold text-lg mb-2">AI-Powered Automation</h4>
              <p className="text-gray-600">
                Smart automation for payroll calculations and compliance
              </p>
            </div>
            <div className="text-center">
              <FaWhatsapp className="text-4xl text-green-600 mx-auto mb-4" />
              <h4 className="font-bold text-lg mb-2">WhatsApp Integration</h4>
              <p className="text-gray-600">
                Send payslips and alerts via WhatsApp instantly
              </p>
            </div>
            <div className="text-center">
              <FaCloud className="text-4xl text-purple-600 mx-auto mb-4" />
              <h4 className="font-bold text-lg mb-2">Cloud Platform</h4>
              <p className="text-gray-600">
                Access from anywhere, anytime with 99.9% uptime
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Login/Register Section */}
      <section
        id="login"
        className="py-16 px-4 bg-gradient-to-r from-blue-50 to-indigo-50"
      >
        <div className="container mx-auto max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Login Form */}
            <Card className="shadow-xl">
              <CardHeader>
                <CardTitle>
                  {loginStep === "email" && "Login to Your Account"}
                  {loginStep === "organizations" && "Select Organization"}
                  {loginStep === "login" && organizations.length === 1 && `Welcome to ${selectedOrg?.company_name}`}
                  {loginStep === "login" && organizations.length > 1 && `Login to ${selectedOrg?.company_name}`}
                </CardTitle>
                <CardDescription>
                  {loginStep === "email" && "Enter your credentials to access the HR dashboard"}
                  {loginStep === "organizations" && `You have access to ${organizations.length} organizations. Choose one to continue.`}
                  {loginStep === "login" && organizations.length === 1 && "Enter your password to access your account"}
                  {loginStep === "login" && organizations.length > 1 && "Enter your password to continue"}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                  {/* Step 1: Email Input */}
                  {loginStep === "email" && (
                    <div className="space-y-2">
                      <Label htmlFor="email">Email</Label>
                      <Input
                        id="email"
                        type="email"
                        placeholder="Enter your email"
                        {...register("email", { required: true })}
                      />
                    </div>
                  )}

                  {/* Step 2: Organizations List (only shown when multiple organizations) */}
                  {loginStep === "organizations" && (
                    <div className="space-y-3">
                      <Label>Select Your Organization</Label>
                      <div className="space-y-2 max-h-80 overflow-y-auto">
                        {organizations.map((org, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => handleSelectOrganization(org)}
                            className="w-full p-4 text-left border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <h3 className="font-semibold text-gray-800">
                                  {org.company_name}
                                </h3>
                                <p className="text-sm text-gray-500 mt-1">
                                  {org.organization}
                                </p>
                              </div>
                              <div className="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-blue-100 flex items-center justify-center transition-colors">
                                <FaBuilding className="w-4 h-4 text-gray-400 group-hover:text-blue-600" />
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Step 3: Password Input */}
                  {loginStep === "login" && (
                    <div className="space-y-2">
                      <Label htmlFor="password">Password</Label>
                      <div className="relative">
                        <Input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          {...register("password", { required: true })}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-3 text-gray-500"
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                      
                      {/* Show organization info on login screen */}
                      {selectedOrg && (
                        <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                          <p className="text-xs text-blue-600">
                            Logging in to: <span className="font-semibold">{selectedOrg.company_name}</span>
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  <Button type="submit" className="w-full" disabled={loading}>
                    {loading ? (
                      <div className="flex items-center justify-center">
                        <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent mr-2"></div>
                        {loginStep === "email" && "Fetching organizations..."}
                        {loginStep === "login" && "Signing in..."}
                      </div>
                    ) : (
                      <>
                        {loginStep === "email" && "Continue"}
                        {loginStep === "organizations" && "Select Organization"}
                        {loginStep === "login" && "Sign In"}
                      </>
                    )}
                  </Button>

                  {/* Back buttons */}
                  {loginStep === "organizations" && (
                    <Button
                      type="button"
                      onClick={handleBackToEmail}
                      variant="outline"
                      className="w-full mt-2"
                    >
                      ← Back to Email
                    </Button>
                  )}

                  {loginStep === "login" && organizations.length > 1 && (
                    <Button
                      type="button"
                      onClick={handleBackToOrganizations}
                      variant="outline"
                      className="w-full mt-2"
                    >
                      ← Back to Organizations
                    </Button>
                  )}
                </form>
                {loginStep === "email" && (
                  <div className="mt-4 text-center">
                    <button
                      onClick={() => navigate("/forgot-password")}
                      className="text-sm text-blue-600 hover:underline"
                    >
                      Forgot Password?
                    </button>
                  </div>
                )}
              </CardContent>
            </Card>

            {/* Register CTA */}
            <div id="register">
              <Card className="shadow-xl bg-gradient-to-br from-blue-600 to-blue-800 text-white">
                <CardContent className="p-8">
                  <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                      <FaUserClock className="text-2xl" />
                    </div>
                    <h3 className="text-2xl font-bold mb-2">
                      Start Your Free Trial
                    </h3>
                    <p className="text-blue-100 mb-6">
                      Join thousands of companies already using HRPayroll
                    </p>
                  </div>

                  <div className="space-y-4 mb-6">
                    <div className="flex items-center">
                      <FaCheckCircle className="text-green-400 mr-3" />
                      <span>30-day free trial</span>
                    </div>
                    <div className="flex items-center">
                      <FaCheckCircle className="text-green-400 mr-3" />
                      <span>No credit card required</span>
                    </div>
                    <div className="flex items-center">
                      <FaCheckCircle className="text-green-400 mr-3" />
                      <span>Full access to all features</span>
                    </div>
                    <div className="flex items-center">
                      <FaCheckCircle className="text-green-400 mr-3" />
                      <span>Priority support</span>
                    </div>
                  </div>

                  <Button
                    onClick={() => navigate("/register")}
                    className="w-full bg-white text-blue-600 hover:bg-gray-100"
                  >
                    Register Now
                  </Button>

                  <p className="text-center mt-4 text-blue-200 text-sm">
                    Paid plans starting from ₹399/month after trial
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-16 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Simple, Transparent Pricing
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Choose the perfect plan for your business needs
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Basic Plan */}
            <Card className="text-center">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-2">Starter</h3>
                <div className="text-3xl font-bold text-blue-600 mb-4">
                  ₹399<span className="text-sm text-gray-500">/month</span>
                </div>
                <p className="text-gray-600 mb-6">
                  Perfect for small businesses
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Up to 10 employees</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Basic payroll processing</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Mobile attendance</span>
                  </div>
                </div>
                <Button className="w-full">Get Started</Button>
              </CardContent>
            </Card>

            {/* Popular Plan */}
            <Card className="text-center border-2 border-blue-600 shadow-xl relative">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm">
                  MOST POPULAR
                </span>
              </div>
              <CardContent className="p-6 pt-10">
                <h3 className="text-xl font-bold mb-2">Professional</h3>
                <div className="text-3xl font-bold text-blue-600 mb-4">
                  ₹899<span className="text-sm text-gray-500">/month</span>
                </div>
                <p className="text-gray-600 mb-6">Best for growing companies</p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Up to 50 employees</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>AI-powered analytics</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Auto reconciliations</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>WhatsApp integration</span>
                  </div>
                </div>
                <Button className="w-full bg-blue-600 hover:bg-blue-700">
                  Try Free for 30 Days
                </Button>
              </CardContent>
            </Card>

            {/* Enterprise Plan */}
            <Card className="text-center">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-2">Enterprise</h3>
                <div className="text-3xl font-bold text-blue-600 mb-4">
                  Custom
                </div>
                <p className="text-gray-600 mb-6">For large organizations</p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Unlimited employees</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Custom integrations</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>Dedicated support</span>
                  </div>
                  <div className="flex items-center">
                    <FaCheckCircle className="text-green-500 mr-2" />
                    <span>API access</span>
                  </div>
                </div>
                <Button className="w-full">Contact Sales</Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <FaUserClock className="text-2xl text-blue-400" />
                <span className="text-xl font-bold">HRPayroll</span>
              </div>
              <p className="text-gray-400">
                Revolutionizing HR management with automated attendance tracking
                and payroll processing.
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => scrollToSection("home")}
                    className="text-gray-400 hover:text-white"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("features")}
                    className="text-gray-400 hover:text-white"
                  >
                    Features
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("pricing")}
                    className="text-gray-400 hover:text-white"
                  >
                    Pricing
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Resources</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => navigate("/blog")}
                    className="text-gray-400 hover:text-white"
                  >
                    Blog
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => navigate("/docs")}
                    className="text-gray-400 hover:text-white"
                  >
                    Documentation
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => navigate("/support")}
                    className="text-gray-400 hover:text-white"
                  >
                    Support
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>info@startupkhata.com support@startupkhata.com</li>
                <li>24/7 Support Available</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>
              &copy; {new Date().getFullYear()} HRPayroll. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;